import { useState } from "react";
import Title from "../../common/Title/Title";
import "./TableOfContent.css";

export default function TableOfContent({ tableOfContents = [] }) {
    const [collapsed, setCollapsed] = useState(false);

    if (!Array.isArray(tableOfContents) || tableOfContents.length === 0) {
        return null;
    }

    const toggleCollapse = () => {
        setCollapsed(!collapsed);
    };

    const renderTableOfContents = (items, parentIndex = "") => {
        return (
            <ul className={`table-content ${collapsed ? "collapsed" : "expanded"}`}>
                {items.map((item, index) => {
                    const currentIndex = parentIndex ? `${parentIndex}.${index + 1}` : `${index + 1}`;
                    return (
                        <li key={currentIndex}>
                            <a href={`#${item.link}`}>{`${currentIndex}. ${item.title}`}</a>
                            {item.subItems && item.subItems.length > 0 && renderTableOfContents(item.subItems, currentIndex)}
                        </li>
                    );
                })}
            </ul>
        );
    };

    return (
        <aside className="table-of-contents">
            <div
                className="table-header"
                onClick={toggleCollapse}
                role="button"
                tabIndex={0}
                aria-expanded={!collapsed}
            >
                <Title
                    text="Table of Contents"
                    size="1.2rem"
                    color="var(--color-blue)"
                />
                <i className={`fas fa-chevron-${collapsed ? "down" : "up"}`} style={{ color: "var(--color-orange)" }}></i>
            </div>
            {renderTableOfContents(tableOfContents)}
        </aside>
    );
}